const pricingDetails = {
  // HeroSection
  'pricingDetails.hero.homeLink': 'ホーム',
  'pricingDetails.hero.pricingLink': '料金・特典',
  'pricingDetails.hero.currentPage': 'コース別料金詳細',
  'pricingDetails.hero.imgAlt': 'コース別受講料の内訳資料と執事道具を並べた静物',

  // breadcrumb (page.tsx)
  'pricingDetails.breadcrumb.home': 'ホーム',
  'pricingDetails.breadcrumb.pricing': '料金・特典',
  'pricingDetails.breadcrumb.current': 'コース別料金詳細',

  // CourseDetailCards
  'pricingDetails.cards.label': 'TUITION BREAKDOWN',
  'pricingDetails.cards.title': '各コースの内訳',
  'pricingDetails.cards.titleEn': 'What Each Course Includes',
  'pricingDetails.cards.lead': 'それぞれのコースで、受講料に何が含まれるのかを詳しくご案内します。授業時間はもちろん、教材・実習・特典・試験料まで、内訳を明確にしています。全額税込です。少人数制で学ぶ日本の執事学校として、コース別の学費内訳を透明にご案内します。',
  'pricingDetails.cards.taxIncluded': '（税込）',
  'pricingDetails.cards.afterExam': '修了実技試験合格後：',
  'pricingDetails.cards.courseLink': 'コースの詳細を見る',
  'pricingDetails.cards.img0Alt': 'エプロン姿でテーブルセッティングを練習する受講生',
  'pricingDetails.cards.img1Alt': 'ワインサービスを実習する受講生',
  'pricingDetails.cards.img2Alt': 'マスターコースのオーダーベストの採寸',
  'pricingDetails.cards.img0Caption': 'テーブルセッティング実習の様子',
  'pricingDetails.cards.img1Caption': '特別実習（ワインサービス体験）の様子',
  'pricingDetails.cards.img2Caption': 'オーダーベスト採寸の様子',

  // TransferDiscount (details page)
  'pricingDetails.transfer.label': 'TRANSFER BENEFIT',
  'pricingDetails.transfer.title': '編入優遇',
  'pricingDetails.transfer.titleEn': 'Lateral Enrollment Discount',
  'pricingDetails.transfer.lead': '段階的に学ぶほど、総額のご負担が軽くなります。',
  'pricingDetails.transfer.discount': '円（税込）減額',
  'pricingDetails.transfer.note': '編入優遇をご利用の際は、お申込み時に前コースの修了証番号を申告してください。',
  'pricingDetails.transfer.consultLink': 'ご不明な点は個別相談にてご確認ください',

  // PaymentFlow
  'pricingDetails.flow.label': 'PAYMENT FLOW',
  'pricingDetails.flow.title': 'お支払いの流れ',
  'pricingDetails.flow.titleEn': 'How Enrollment Works',
  'pricingDetails.flow.lead': 'お申込み後、受講契約のご案内をお送りします。受講料のお振込みを確認した時点で、受講確定となります。',
  'pricingDetails.flow.importantTitle': 'お支払いに関する重要事項',
  'pricingDetails.flow.note1': '銀行振込による一括払いのみ（分割払い・クレジットカードはご利用いただけません）',
  'pricingDetails.flow.note2': 'お支払い期限は開校日の14日前です',
  'pricingDetails.flow.note3': '振込手数料はお客様のご負担となります',
  'pricingDetails.flow.note4': '期限までにご入金が確認できない場合、お申込みが取り消されることがあります',

  // CTASection
  'pricingDetails.cta.label': 'NEXT STEP',
  'pricingDetails.cta.title': 'ご不明な点はお気軽に',
  'pricingDetails.cta.lead': '料金やお支払いについてご不明な点は、個別相談にて丁寧にご説明いたします。執事学校の費用についてもお気軽にご相談ください。まずは無料の資料請求からどうぞ。',
  'pricingDetails.cta.onlineNote': '※ご相談はオンラインでも承ります',
  'pricingDetails.cta.backBtn': '料金概要に戻る',
  'pricingDetails.cta.brochureBtn': '資料請求はこちら（無料）',
  'pricingDetails.cta.consultBtn': '個別相談を予約する',

  // FAQSection
  'pricingDetails.faq.label': 'FAQ',
  'pricingDetails.faq.title': 'よくあるご質問',
  'pricingDetails.faq.titleEn': 'Frequently Asked Questions',
  'pricingDetails.faq.contactNote': 'その他のご質問は',
  'pricingDetails.faq.contactLink': 'お問い合わせ',
  'pricingDetails.faq.contactSuffix': 'よりお寄せください',

  // RelatedPages
  'pricingDetails.related.label': 'LEARN MORE',
  'pricingDetails.related.title': '関連ページ',
  'pricingDetails.related.titleEn': 'Explore Further',
  'pricingDetails.related.arrowLabel': '詳しく見る',

  // footer
  'pricingDetails.footer.lastUpdated': '最終更新: 2026年6月13日',
  'pricingDetails.backToTop.ariaLabel': 'ページの先頭へ戻る',
};

export default pricingDetails;
